// extracted by mini-css-extract-plugin
var _1 = "WrappingTwoColumnLayout-module__container--Db7v9";
var _2 = "WrappingTwoColumnLayout-module__left--sNpWW";
var _3 = "WrappingTwoColumnLayout-module__right--c3nNI";
export { _1 as "container", _2 as "left", _3 as "right" }
